var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":"M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }